import { createSlice } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
//import { createAsyncThunk } from '@reduxjs/toolkit';

type FamilyLogInfo = {
	FamilyMemberID: string;
	PlatformInformation: string;
	LoginString: string;
}

export const logFamilyInfo =
	(log: FamilyLogInfo) => {
		console.log('logFamilyInfo params', log);
		return api.post(
			`/family_member/log_info`
		);

	}
export const familyMemberMe = () => {
		console.log('me params', `/family_member/me`, api);
		return api.get(`/family_member/me`
		);

	}


const initialState: {
	status: string;
	error: string;
	data: any;
} = {
	status: '',
	error: '',
	data: {

	},
};

const familySlice = createSlice({
	name: 'familySlice',
	initialState: initialState,
	reducers: {
		classsSessionPatientSliceClean(state, action) {
			console.log('classsSessionPatientSliceClean', action);
			state.data = {};
			state.data.pending = false;
			state.data.complete = false;
			state.data.error = '';
		},
	},

	extraReducers: () => {
		//getClassSessionPatient


	},
});



export const { classsSessionPatientSliceClean} = familySlice.actions;


export default familySlice;
